<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.9 12C3.9 10.29 5.29 8.9 7 8.9H10.05C10.5747 8.9 11 8.47467 11 7.95C11 7.42533 10.5747 7 10.05 7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H10.05C10.5747 17 11 16.5747 11 16.05C11 15.5253 10.5747 15.1 10.05 15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 12C8 12.5523 8.44772 13 9 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H9C8.44772 11 8 11.4477 8 12ZM13.95 7H17C19.76 7 22 9.24 22 12C22 14.76 19.76 17 17 17H13.95C13.4253 17 13 16.5747 13 16.05C13 15.5253 13.4253 15.1 13.95 15.1H17C18.71 15.1 20.1 13.71 20.1 12C20.1 10.29 18.71 8.9 17 8.9H13.95C13.4253 8.9 13 8.47467 13 7.95C13 7.42533 13.4253 7 13.95 7Z"
  />
</template>
